export default function Services() {
  const services = [
    {
      title: 'Interior Design',
      description: 'Transform your space with our comprehensive design services',
      features: ['Space Planning', '3D Visualization', 'Material Selection', 'Project Management'],
      image: 'https://readdy.ai/api/search-image?query=elegant%20interior%20design%20workspace%20with%20mood%20boards%20fabric%20swatches%20color%20palettes%20design%20tools%20modern%20studio%20environment%20creative%20professional%20setting%20natural%20lighting%20minimalist%20aesthetic%20contemporary%20furniture&width=600&height=400&seq=service-interior&orientation=landscape',
      icon: 'ri-home-smile-line'
    },
    {
      title: 'Digital Solutions',
      description: 'Custom web development and digital experiences for your brand',
      features: ['Website Design', 'E-commerce', 'Brand Identity', 'Digital Marketing'],
      image: 'https://readdy.ai/api/search-image?query=modern%20web%20design%20interface%20on%20computer%20screen%20clean%20minimalist%20website%20layout%20responsive%20design%20mockups%20digital%20workspace%20contemporary%20office%20setting%20professional%20technology%20environment%20sleek%20aesthetic&width=500&height=400&seq=service-web&orientation=landscape',
      icon: 'ri-code-s-slash-line'
    },
    {
      title: 'Consultation & Booking',
      description: 'Expert guidance from concept to completion',
      features: ['Design Consultation', 'Project Planning', 'Budget Analysis', 'Timeline Management'],
      image: 'https://readdy.ai/api/search-image?query=professional%20consultation%20meeting%20modern%20office%20interior%20design%20discussion%20calendar%20scheduling%20business%20meeting%20contemporary%20workspace%20collaborative%20environment%20natural%20lighting%20clean%20aesthetic&width=500&height=400&seq=service-consult&orientation=landscape',
      icon: 'ri-calendar-check-line'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-16">
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 lg:mb-0" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our<br />Expertise
          </h2>
          <p className="text-gray-600 text-base max-w-md lg:mt-2">
            Comprehensive design and digital services tailored to your vision.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 bg-gray-50 rounded-2xl p-8 flex flex-col">
            <div className="w-full h-64 mb-6 rounded-xl overflow-hidden">
              <img
                src={services[0].image}
                alt={services[0].title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center">
                <i className={`${services[0].icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">{services[0].title}</h3>
            </div>
            <p className="text-gray-600 text-sm mb-6">{services[0].description}</p>
            <div className="flex flex-wrap gap-2">
              {services[0].features.map((feature, idx) => (
                <span key={idx} className="text-xs text-gray-700 bg-white px-3 py-1.5 rounded-full">
                  {feature}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6">
            {services.slice(1).map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-8 flex flex-col">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center">
                    <i className={`${service.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-gray-600 text-sm mb-6">{service.description}</p>
                <div className="w-full h-48 mb-6 rounded-xl overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-wrap gap-2 mt-auto">
                  {service.features.map((feature, idx) => (
                    <span key={idx} className="text-xs text-gray-700 bg-white px-3 py-1.5 rounded-full">
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
